import { OrigemConsultaControleEstoqueEnum } from '../../../enums/produto/origem-consulta-controle-estoque.enum';

export class ControleEstoqueListaRequest {
  searchText?: string;
  idControleEstoqueListaRefinamento: number = 0;
  idTipoMovimentoFiltro: number = 0;
  idResumoFiltro: number = 0;
  origem: OrigemConsultaControleEstoqueEnum = OrigemConsultaControleEstoqueEnum.ControleEstoque;
}
